import * as React from "react";
const SvgPipeline = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", height: 24, width: 24, ...props }, /* @__PURE__ */ React.createElement("path", { style: {
  color: "#000000",
  fontStyle: "normal",
  fontVariant: "normal",
  fontWeight: "normal",
  fontStretch: "normal",
  fontSize: "medium",
  lineHeight: "normal",
  fontFamily: "sans-serif",
  textIndent: 0,
  textAlign: "start",
  textDecoration: "none",
  textDecorationLine: "none",
  textDecorationStyle: "solid",
  textDecorationColor: "#000000",
  letterSpacing: "normal",
  wordSpacing: "normal",
  textTransform: "none",
  writingMode: "lr-tb",
  direction: "ltr",
  baselineShift: "baseline",
  textAnchor: "start",
  whiteSpace: "normal",
  clipRule: "nonzero",
  display: "inline",
  overflow: "visible",
  visibility: "visible",
  opacity: 1,
  isolation: "auto",
  mixBlendMode: "normal",
  colorInterpolation: "sRGB",
  colorInterpolationFilters: "linearRGB",
  solidColor: "#000000",
  solidOpacity: 1,
  fill: "#53c3c4",
  fillOpacity: 1,
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: 2.36303,
  strokeLinecap: "round",
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1,
  colorRendering: "auto",
  imageRendering: "auto",
  shapeRendering: "auto",
  textRendering: "auto",
  enableBackground: "accumulate"
}, d: "m 16.180733,4.4778047 c -0.225712,-9.036e-4 -0.447587,0.00881 -0.664725,0.028102 C 13.778895,4.6602 12.310021,5.3650171 11.351491,5.8248197 10.345127,6.307569 9.0772298,7.0667616 7.7423285,7.3987385 6.4074274,7.7307155 5.1288775,7.6809549 3.8672819,6.5842574 A 1.0898647,1.2811267 0 1 0 2.5712276,8.644132 C 4.4094203,10.242054 6.4885583,10.329324 8.1935554,9.9053072 9.8985627,9.4812892 11.35277,8.5914861 12.17503,8.1970524 13.119637,7.7439286 14.355443,7.1782597 15.680225,7.0605906 17.005,6.9429206 18.384236,7.2200873 19.831155,8.5577185 A 1.0898647,1.2811267 0 1 0 21.178446,6.5440337 C 19.528655,5.0188481 17.760694,4.4842661 16.180733,4.4778067 Z m 0,5.1239955 c -0.225712,-8.8e-4 -0.447587,0.0088 -0.664725,0.0281 -1.737113,0.154294 -3.205987,0.8591118 -4.164517,1.3189138 -1.006364,0.482749 -2.2742612,1.241941 -3.6091625,1.573918 -1.3349011,0.331976 -2.613451,0.282218 -3.8750466,-0.81448 a 1.0898647,1.2811267 0 1 0 -1.2960543,2.059877 c 1.8381927,1.597922 3.9173307,1.685194 5.6223278,1.261176 1.7050073,-0.424019 3.1592146,-1.313823 3.9814746,-1.708255 0.944607,-0.453126 2.180413,-1.018793 3.505195,-1.136462 1.324775,-0.117671 2.704011,0.159496 4.15093,1.497128 a 1.0898647,1.2811267 0 1 0 1.347291,-2.013685 C 19.528655,10.142845 17.760694,9.6082632 16.180733,9.6018042 Z m 0,5.1239928 c -0.225712,-8.95e-4 -0.447587,0.0088 -0.664725,0.0281 -1.737113,0.154293 -3.205987,0.85911 -4.164517,1.318912 -1.006364,0.48275 -2.2742612,1.241942 -3.6091625,1.573919 -1.3349011,0.331978 -2.613451,0.282218 -3.8750466,-0.814481 a 1.0898647,1.2811267 0 1 0 -1.2960543,2.059876 c 1.8381927,1.597923 3.9173307,1.685195 5.6223278,1.261175 1.7050073,-0.424017 3.1592146,-1.31382 3.9814746,-1.708255 0.944607,-0.453124 2.180413,-1.018792 3.505195,-1.136462 1.324775,-0.117671 2.704011,0.159498 4.15093,1.497129 a 1.0898647,1.2811267 0 1 0 1.347291,-2.013685 c -1.649791,-1.525185 -3.417752,-2.059767 -4.997713,-2.066226 z" }));
export default SvgPipeline;
